<template>
  <video class="video" src="video/tomap.mp4" muted preload="auto" autoplay id="main-wel-bg-video"></video>
</template>

<script>
export default {
  name: "main-wel-bg",
  data() {
    return {
      video: null
    }
  },
  methods: {
    play() {
      this.video.play();
    },
    ended() {
      this.$emit("vend")
    },
    ing() {
      if (this.video.currentTime >= 4.5) {
        //console.log("ok");
        clearInterval(this.m);
        this.$emit("complete")
      }
    }
  },
  mounted() {
    this.video = $("#main-wel-bg-video").get(0);
    this.video.addEventListener("ended", this.ended)
    this.m = setInterval(this.ing, 500);
    //this.video.addEventListener("durationchange", this.durationchange)
  },
  beforeDestroy() {
    clearInterval(this.m);
    this.video.removeEventListener("ended", this.ended);
  },
  destroyed() {
    //this.video.removeEventListener("ended", this.ended);
  }
}
</script>

<style scoped>
.video {
  /*  background-color: #0d1a4c;
    object-fit: contain;*/
  object-fit: cover;
}
</style>
